/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export const CommonRegExp = {
    Alphabet: /^[a-z'_\-.]$/i,
    Chinese: /[\u4e00-\u9fa5]/,
    Number: /[0-9]/,
    WhiteSpace: /\s/,
    Symbol: /[=><!]/,
    Time: /[0-9-]/,
};
export const isAlphabet = (value: string): boolean => CommonRegExp.Alphabet.test(value);
export const isNumber = (value: string): boolean => CommonRegExp.Number.test(value);
export const isBlank = (value: string): boolean => CommonRegExp.WhiteSpace.test(value);
export const isSymbol = (value: string): boolean => CommonRegExp.Symbol.test(value);
export const isChinese = (value: string): boolean => CommonRegExp.Chinese.test(value);
export const isTime = (value: string): boolean => CommonRegExp.Time.test(value);
export const isHyphenBlank = (value: string): boolean => {
    if (value) {
        return isSymbol(value) ? true : CommonRegExp.WhiteSpace.test(value);
    } else {
        return true;
    }
};
export const isString = (value: string): boolean => Boolean(value);
